/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_OfferInputs */

const en_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer`)
};

const de_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot`)
};

const fr_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre`)
};

const es_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const it_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta`)
};

const nl_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod`)
};

const pl_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const fi_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjous`)
};

const da_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const sv_applications_status_offer = /** @type {(inputs: Applications_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudande`)
};

/**
* | output |
* | --- |
* | "Offer" |
*
* @param {Applications_Status_OfferInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_offer = /** @type {((inputs?: Applications_Status_OfferInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_OfferInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_offer(inputs)
	if (locale === "fr") return fr_applications_status_offer(inputs)
	if (locale === "es") return es_applications_status_offer(inputs)
	if (locale === "it") return it_applications_status_offer(inputs)
	if (locale === "nl") return nl_applications_status_offer(inputs)
	if (locale === "pl") return pl_applications_status_offer(inputs)
	if (locale === "fi") return fi_applications_status_offer(inputs)
	if (locale === "da") return da_applications_status_offer(inputs)
	if (locale === "sv") return sv_applications_status_offer(inputs)
	return en_applications_status_offer(inputs)
});